import Mmenu from 'mmenu-js';
import 'mburger-webcomponent/dist/mburger/index';

export function initializeMobileMenu() {

    new Mmenu('#mobile-menu', {
        theme: 'dark',
    });

}

var sum_menus, main_menus, active_category, header, topBar, submenuContainers, topBarHeight, headerHeight,
    fullHeaderHeight;

export function initializeDesktopMenu() {

    // wyłącz dla iOS i mobilnych rozdzielczości


// pobieramy element z klasą "header" i "top-bar"
    header = document.querySelector('.header');
    topBar = document.querySelector('.top-bar');
    // submenuContainers = document.querySelectorAll('.submenu__container');

    // jeśli nie ma elementu ".header" to kończymy działanie funkcji
    if (!header || !topBar) {
        return;
    }

// pobieramy wysokość elementu "top-bar"

    // topBarHeight = topBar.offsetHeight;
    // headerHeight = header.offsetHeight;
    // fullHeaderHeight = topBarHeight + headerHeight;


    // // jeśli jesteśmy w widoku mobilnym lub korzystamy z iOS to nie dodajemy sticky header
    // if (window.innerWidth > 1024 && !navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
    //
    //     // dodajemy event listener na scroll
    //     setFloatingHeader();
    //     window.addEventListener('scroll', () => {
    //         setFloatingHeader();
    //     });
    //     window.addEventListener('resize', () => {
    //         setFloatingHeader();
    //     });
    // }

    const menu = document.querySelector('.menu--primary');
    const products_menu = menu.querySelector('.menu__item.products');

    sum_menus = products_menu.querySelectorAll('.products-nav-sub');
    main_menus = products_menu.querySelectorAll('.products-nav-main__item');
    active_category = main_menus[0].dataset.name;


    menu.querySelectorAll('.menu-item-has-children, .menu__item.products').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
            item.classList.add('active');
        });
        item.addEventListener('mouseleave', function () {
            item.classList.remove('active');
        });
    });

    // jeśli najedziemy na .submenu to wykrywamy wszystkie aktywne menu z dziećmi
    menu.querySelectorAll('.submenu__background').forEach(function (submenu) {
        submenu.addEventListener('mouseenter', function () {
            let isCursorOverSubmenu = false; // zmienna, która będzie przechowywać informację, czy kursor jest nad elementem ".submenu__background"
            setTimeout(function () {
                if (isCursorOverSubmenu) { // sprawdzenie, czy kursor jest nad elementem ".submenu__background"
                    let active_menu = menu.querySelector('.menu__item.active');
                    if (active_menu) {
                        active_menu.classList.remove('active');
                    }
                }
            }, 50);
            submenu.addEventListener('mouseleave', function () { // ustawienie zmiennej isCursorOverSubmenu na false, gdy kursor opuszcza element ".submenu__background"
                isCursorOverSubmenu = false;
            });
            submenu.addEventListener('mousemove', function () { // ustawienie zmiennej isCursorOverSubmenu na true, gdy kursor jest nad elementem ".submenu__background"
                isCursorOverSubmenu = true;
            });
        });
    });

    // jeśli najedziemy na products_menu to pokazuje się pierwsza kategoria sum_menus
    products_menu.addEventListener('mouseenter', function () {

        active_category = main_menus[0].dataset.name;
        showActiveCategory();
    });

    // jeśli najedziemy na kategorię to pokazuje się odpowiednia podkategoria
    main_menus.forEach(function (category_menu) {
        category_menu.addEventListener('mouseenter', function () {
            console.log(category_menu.dataset.name);
            active_category = category_menu.dataset.name;
            showActiveCategory();
        });
    });


}

// export function initializeCompaniesBar() {
//     const companiesBar = document.querySelector('.companies-bar');
//     const companiesBarLink = document.querySelector('.top-bar__companies');
//     if (companiesBarLink && companiesBar) {
//         companiesBarLink.addEventListener('click', function (e) {
//             e.preventDefault();
//             var status = companiesBar.classList.toggle('companies-bar--active');
//             companiesBarLink.classList.toggle('top-bar__companies--active', status);
//         });
//     }
// }


function showActiveCategory() {
    sum_menus.forEach(function (sum_menu) {
        if (sum_menu.dataset.name === active_category) {
            sum_menu.classList.add('active');
        } else {
            sum_menu.classList.remove('active');
        }
    });

    main_menus.forEach(function (category_menu) {
        if (category_menu.dataset.name === active_category) {
            category_menu.classList.add('active');
        } else {
            category_menu.classList.remove('active');
        }
    });
}


// function setFloatingHeader() {
//
//     document.querySelector('header').style.height = fullHeaderHeight + 'px';
//     // pobieramy aktualną pozycję scrolla
//     const scrollPosition = window.scrollY;
//     var scrollPoint = fullHeaderHeight;
//     if (header.classList.contains('header--fixed')) {
//         scrollPoint = topBarHeight;
//     }
//     // sprawdzamy, czy użytkownik przewinął ekran
//     if (scrollPosition > scrollPoint) {
//         // jeśli tak, ustawiamy pozycję "fixed" dla nagłówka
//         header.classList.add('header--fixed');
//         submenuContainers.forEach(submenuContainer => {
//             submenuContainer.style.marginTop = headerHeight + 'px';
//         });
//
//     } else {
//         // jeśli nie, ustawiamy pozycję "relative" dla nagłówka
//         header.classList.remove('header--fixed');
//         submenuContainers.forEach(submenuContainer => {
//             submenuContainer.style.marginTop = fullHeaderHeight - scrollPosition + 'px';
//         });
//     }
// }
